import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/plugins/i18n'
import web3ModalStore from './web3modal.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbarAlerts: []
  },
  getters: {
    snackbarAlerts (state) {
      return state.snackbarAlerts
    }
  },
  mutations: {
    setSnackbarAlerts (state, payload) {
      state.snackbarAlerts = payload
    },
    pushSnackbarAlert (state, payload) {
      state.snackbarAlerts.push(payload)
    },
    clearSnackbarAlerts (state, payload) {
      state.snackbarAlerts = state.snackbarAlerts
        .filter(snackbarAlert => (
          payload.indexOf(snackbarAlert.id) === -1
        ))
    }
  },
  actions: {
    alertShow ({ commit }, payload) {
      let shouldThrow = false
      const snackAlert = { id: Date.now() }

      if (payload.error) {
        snackAlert.type = 'error'
        snackAlert.color = 'error'
        if (typeof payload.error === 'string') {
          snackAlert.message = payload.error
        } else if (typeof payload.error === 'object' && payload.error != null && payload.error.fmc != null) {
          snackAlert.message = i18n.t('error.' + payload.error.fmc)
        } else {
          snackAlert.message = i18n.t('error.generic')
          shouldThrow = true
        }
      } else if (payload.warning) {
        snackAlert.type = 'warning'
        snackAlert.color = 'warning'
        snackAlert.message = payload.warning
      } else if (payload.success) {
        snackAlert.type = 'success'
        snackAlert.color = 'success'
        snackAlert.message = payload.success
      } else if (payload.info) {
        snackAlert.type = 'info'
        snackAlert.color = 'info'
        snackAlert.message = payload.info
      }

      commit('pushSnackbarAlert', snackAlert)
      if (!payload.persist) {
        setTimeout(() => {
          commit('clearSnackbarAlerts', [snackAlert.id])
        }, payload.timeout || 3000)
      }
      if (shouldThrow) {
        throw payload
      }
    },
    alertsHide ({ commit }, alertIds) {
      if (alertIds) {
        commit('clearSnackbarAlerts', alertIds)
      } else {
        commit('setSnackbarAlerts', [])
      }
    }
  },
  modules: {
    web3Modal: web3ModalStore
  }
})
